import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import { SlabCreamContainer } from 'src/elements/geometry/slab.cream.styles';
import Heading from 'src/elements/typography/heading';
import { CarrerListContainer, JobDepartment, JobList, JobListColumn } from './careers.list.styles';

interface GreenHouseJobList {
  departments: {
    id: number;
    name: string;
    jobs: {
      id: string;
      absolute_url: string;
      internal_job_id: number;
      title: string;
      updated_at: string;
      location: { name: string; }
    }[]
  }[]
}

interface CareersListProps {
  title: string;
}


const CareersList = ({ title }: CareersListProps): JSX.Element => {

  const [ jobList, setJobList ] = useState<GreenHouseJobList>(null);

  useEffect(() => {
    if (fetch) {
      fetch(`https://boards-api.greenhouse.io/v1/boards/mightynetworks/departments/`)
        .then((response) => response.json())
        .then((jobListData: GreenHouseJobList) => {
          setJobList(jobListData);
        })
    }
  }, [])

  return (
    <SlabCreamContainer>
      <CarrerListContainer id="jobs">
        <Heading
          text={title}
          size="2.5em"
          align="center"
        />
        <JobList>
          {
            !jobList ? null :
              jobList.departments.filter(department => department.jobs.length).map((department, index) => (
                <FadeInAnimationWrapper key={index}>
                  <JobListColumn>
                    <Heading
                      text={department.name}
                      size="1.5em"
                      sizeMd="1.25em"
                      weight="normal" />
                    <JobDepartment>
                      {
                        department.jobs.map((job) => (
                          <li key={job.internal_job_id}>
                            <Link to={encodeURI(`/job/details?title=${job.title} | ${job.location.name}&id=${job.id}`)}>
                              {job.title}
                            </Link>
                          </li>

                        ))
                      }
                    </JobDepartment>
                  </JobListColumn>
                </FadeInAnimationWrapper>
              ))
          }
        </JobList>
      </CarrerListContainer>
    </SlabCreamContainer>
  )
}

export default CareersList;
